import { formatNumber } from '../number/format';

const counterUp = function() {
    const init = function( to: number, parent: HTMLElement ) {
        const dest = parent.querySelectorAll( '.count-number' );
        const animationDurationInMS = 800; // ms
        const maxSteps = 40;
        const intervalDurationInMS = animationDurationInMS / maxSteps;

        dest.forEach( function( el: HTMLElement ) {
            const from = parseInt( el.dataset.from || '0' );
            const difference = to - from;
            const step = Math.ceil( difference / maxSteps );

            // if step is 0 then we can just terminate
            if ( step === 0 ) {
                el.dataset.from = to.toString();
                el.innerText = formatNumber( to );
                return;
            }

            const intervalFunc = window.setInterval( update, intervalDurationInMS );

            let current = from;

            function update() {
                current += step;

                if ( difference >= 0 && current >= to ) {
                    current = to;
                    window.clearInterval( intervalFunc );
                    el.dataset.from = to.toString();
                } else if ( difference <= 0 && current <= to ) {
                    current = to;
                    window.clearInterval( intervalFunc );
                    el.dataset.from = to.toString();
                }
                el.innerText = formatNumber( current );
            }
        } );
    };

    return {
        init: function( to, parent ) {
            init( to, parent );
        },
    };
}();

function showResultNumsButton( to, parent ) {
    parent.querySelectorAll( '.count-number, .txt-see' ).forEach( function( el ) {
        el.classList.remove( 'd-none' );
    } );
    parent.querySelectorAll( '.txt-search' ).forEach( function( el ) {
        el.classList.add( 'd-none' );
    } );
    counterUp.init( to, parent );
}

export function doSearch( form: HTMLFormElement, originalEvent?: Event | CustomEvent ) {
    const url = new URL( window.location.origin + form.dataset.keepCountEndpoint );
    const formData = new FormData( form );

    const mapSpecificValues = [ 'map-area', 'search-this-area', 'draw-your-search' ];

    if ( mapSpecificValues.includes( formData.get( 'locationId' ) as string || '' ) ) {
        formData.delete( 'locationId' );
        formData.delete( 'locationFreeText' );
    }

    if ( originalEvent && originalEvent instanceof CustomEvent && originalEvent.detail && originalEvent.detail.extraValues ) {
        Object.keys( originalEvent.detail.extraValues ).forEach( function( key ) {
            formData.set( key, originalEvent.detail.extraValues[ key ] );
        } );
    }

    return window.http( url, {
        method: 'POST',
        body: formData,
    } )
        .then( function( response ) {
            if ( !response.ok ) {
                throw new Error( 'failed getting search count' );
            }
            return response.json();
        } )
        .then( function( result ) {
            if ( !result.success ) {
                throw new Error( 'failed getting search count' );
            }
            showResultNumsButton( result.data, form );
        } );
}

export function keepCountOnForm( form: HTMLFormElement, triggerNow: boolean ) {
    const tryDoSearch = function( event?: Event ) {
        if ( window.searchTriggered ) {
            return;
        }

        window.searchTriggered = true;

        window.setTimeout( function() {
            window.searchTriggered = false;
            doSearch( form, event );
        }, 500 );
    };

    form.addEventListener( 'change', function( event ) {
        const target = event.target as HTMLElement;

        const ignore = (
            target &&
            target.dataset.triggerCountOnChange &&
            target.dataset.triggerCountOnChange === 'false'
        );

        if ( ignore ) {
            return;
        }

        tryDoSearch( event );
    } );

    form.querySelectorAll<HTMLInputElement | HTMLSelectElement>( 'input,select' ).forEach( function( el ) {
        if ( el.dataset.triggerCountOnChange && el.dataset.triggerCountOnChange === 'false' ) {
            return;
        }

        el.addEventListener( 'change', tryDoSearch );
    } );

    const typeahead = form.querySelector( 'input[name="locationFreeText"]' );

    if ( typeahead ) {
        typeahead.addEventListener( 'awesomplete-selectcomplete', tryDoSearch );
    }

    const categoryTypeahead = form.querySelector( 'input[name="categoryFreeText"]' );

    if ( categoryTypeahead ) {
        categoryTypeahead.addEventListener( 'awesomplete-selectcomplete', tryDoSearch );
    }

    if ( triggerNow ) {
        tryDoSearch();
    }
}

export default function initPropertySearch() {
}
